import React from "react";
import { Select } from "@components/formx";
import locale from "@bonliva-crm/locale";
import { ConsultantEditorStore } from "../ConsultantEditorStore";
import { useConsultantEditorContext } from "../ConsultantEditorContext";

export function CompetitorInfo() {
  const editorStore: ConsultantEditorStore = useConsultantEditorContext();
  return (
    <Select
      multi
      name="competitors.items"
      label={locale["Works for competitors"]}
      options={editorStore.allCompetitors.map((u) => ({
        label: u,
        value: u
      }))}
    />
  );
}
